(function(){
  var root = document.querySelector('[data-stono-branded-search-lander]');
  if (!root) return;
  var fork = root.querySelector('#start'),
      bar  = root.querySelector('#stickyCta');
  if(!('IntersectionObserver' in window) || !fork || !bar){ return; }
  new IntersectionObserver(function(entries){
    var past = entries[0].boundingClientRect.top < 0;
    bar.classList.toggle('show', past);
    root.classList.toggle('has-sticky', past);
  },{threshold:0}).observe(fork);
})();
